import { render, staticRenderFns } from "./EditProfileForm.vue?vue&type=template&id=8bc9d6c6&"
import script from "./EditProfileForm.vue?vue&type=script&lang=js&"
export * from "./EditProfileForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8bc9d6c6')) {
      api.createRecord('8bc9d6c6', component.options)
    } else {
      api.reload('8bc9d6c6', component.options)
    }
    module.hot.accept("./EditProfileForm.vue?vue&type=template&id=8bc9d6c6&", function () {
      api.rerender('8bc9d6c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Profile/EditProfileForm.vue"
export default component.exports